<!--
 Created by Dmytro Sav. on 4/28/2020
 Copyright © 2020 Curriculum Ltd. All rights reserved.
-->

<div class="intro-section" *ngIf="question.isMaster">
  <div class="intro-question" [currMath]="question.question"></div>
</div>

<div class="panel-content-inside curr-students-list-question" *ngIf="!question.isMaster">
  <div class="panel-content-inside-item">
    <curr-review-test-question-card
      [isCumulativeTests]="true"
      [showAddToSessionBtn]="false"
      [courseId]="courseId"
      [showTitle]="false"
      [isNotViewMode]="true"
      [incomingQuestion]="question">
    </curr-review-test-question-card>

    <div class="student-data" *ngIf="question.newStudentAnswers">
      <curr-student-answer [answerData]="question.newStudentAnswers" [studentData]="studentData"></curr-student-answer>
    </div>
  </div>
  <div class="panel-content-inside-item">
    <div class="panel-content-item">
      <div class="item-main-title" *ngIf="!question.markType || question.markType === 'SELF_MARKED'">{{ 'teacher.studentsList.question.studentSelfMarking' | translate }}</div>
      <div class="item-main-title" *ngIf="question.markType === 'AI_MARKED' && question.answerType === qt.OPEN_ENDED">{{ 'teacher.studentsList.question.aiComments' | translate }}</div>

      <div class="self-mark-data" *ngIf="(!question.markType || question.markType === 'SELF_MARKED') && question.newStudentAnswers && question.newStudentAnswers.selfMark">
        <div class="self-mark-data-row" *ngIf="question.newStudentAnswers.selfMark.selfMarkSchemas.length > 0 && checkHasNotCorrectSelfMark(question.newStudentAnswers.selfMark.selfMarkSchemas)">
          <div class="row-title">{{ 'teacher.studentsList.question.marks' | translate }}</div>
          <div class="row-content">
            <div class="open-ended-answers">
              <ng-container *ngFor="let selfMark of question.newStudentAnswers.selfMark.selfMarkSchemas; let i = index">
                <div class="open-ended-answers-row" *ngIf="!selfMark.correct">
                  <div class="open-ended-cell open-ended-answer">
                    <div class="open-ended-title">{{ 'teacher.studentsList.question.answer' | translate }}</div>
                    <div class="open-ended-desc" [currMath]="selfMark.key"></div>
                  </div>
                  <div class="open-ended-cell open-ended-mark">
                    <div class="open-ended-title">{{ 'teacher.studentsList.question.mark' | translate }}</div>
                    <div class="open-ended-desc">{{ selfMark.mark }}</div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="self-mark-data-row" *ngIf="question.newStudentAnswers.selfMark.reasons.length > 0 && question.newStudentAnswers.selfMark.reasons[0]">
          <div class="row-title">{{ 'teacher.studentsList.question.studentProvidedInsight' | translate }}</div>
          <div class="row-content">
            <div class="reason" *ngFor="let reason of question.newStudentAnswers.selfMark.reasons; let i = index">{{ reason }}</div>
          </div>
        </div>
        <div class="self-mark-data-row" *ngIf="question.newStudentAnswers.selfMark.comment">
          <div class="row-title">{{ 'teacher.studentsList.question.studentComments' | translate }}</div>
          <div class="row-content" [currMath]="question.newStudentAnswers.selfMark.comment"></div>
        </div>
      </div>

      <div *ngIf="question.newStudentAnswers">
        <div class="ai-comments" *ngIf="question.markType === 'AI_MARKED' && question.answerType === qt.OPEN_ENDED">
          <div class="ai-comments-label">{{ 'teacher.studentsList.question.whatDidStudentForget' | translate }}</div>
          <div class="ai-comments-content" [currMath]="question.newStudentAnswers.aiMark?.insights || ('teacher.studentsList.question.noData' | translate)"></div>

          <div class="ai-comments-label">{{ 'teacher.studentsList.question.generalWeaknesses' | translate }}</div>
          <div class="ai-comments-content" [currMath]="question.newStudentAnswers.aiMark?.highlights || ('teacher.studentsList.question.noData' | translate)"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="bottom-section-mark" *ngIf="question.newStudentAnswers && !question.isMaster">{{ 'teacher.studentsList.question.marksAwarded' | translate }} <span>{{question.newStudentAnswers.resultMark}}</span></div>
